import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
const FOR_YOU = ['Sentís que algo no cierra, aunque afuera estés bien', 'Querés tomar decisiones con claridad y sin dudar días enteros', 'Estás dispuesto a trabajar — no solo a inspirarte', 'Querés ser el padre, la pareja, la persona que podés ser', 'Estás listo para 12 semanas de compromiso real'];
const NOT_FOR_YOU = ['Buscás un hack rápido sin proceso', 'No estás dispuesto a mirarte con honestidad', 'Querés resultado sin cambiar nada'];
export function ForWhomSection() {
  return <section id="for-whom" className="py-14 md:py-32 bg-charcoal" data-id="element-108" data-mp="o7be7mwrj3lq">
      <div className="max-w-5xl mx-auto px-6" data-id="element-109" data-mp="o95uup1049k0">
        <FadeIn className="text-center mb-10 md:mb-16" data-id="element-110" data-mp="t4v2zgr36yrx">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite" data-id="element-111" data-mp="38x0qbs630baq">
            Para quién es ELEVATE
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 md:gap-12" data-id="element-112" data-mp="3dwwsrmz4ruo6">
          <FadeIn direction="right" data-id="element-113" data-mp="34ritymnpiujt">
            <div className="bg-charcoal-dark border border-sand/30 p-8 md:p-10 rounded-sm h-full" data-id="element-114" data-mp="34su0uvcg8if5">
              <h3 className="text-2xl font-heading font-bold text-sand mb-8" data-id="element-115" data-mp="2zuiniamy3ps6">
                Es para vos si:
              </h3>
              <ul className="space-y-6" data-id="element-116" data-mp="3dqcma0u08yrk">
                {FOR_YOU.map(item => <li key={item} className="flex items-start gap-4" data-id="element-117" data-mp="38sb4rkc897i7">
                    <div className="bg-sand/10 p-1 rounded-sm shrink-0 mt-0.5" data-id="element-118" data-mp="3npv68h9x0kjm">
                      <CheckIcon className="w-5 h-5 text-sand" data-id="element-119" data-mp="3isboh7e0dpmx" />
                    </div>
                    <span className="text-offwhite-dim text-lg" data-id="element-120" data-mp="ec9kkx2xq5r">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.15} data-id="element-121" data-mp="3sjzd70j6kskp">
            <div className="bg-charcoal-dark border border-charcoal-light p-8 md:p-10 rounded-sm h-full" data-id="element-122" data-mp="ad1tskcg7mp6">
              <h3 className="text-2xl font-heading font-bold text-offwhite-dim mb-8" data-id="element-123" data-mp="5e8dyl9ovjlu">
                No es para vos si:
              </h3>
              <ul className="space-y-6" data-id="element-124" data-mp="2z32c3hniam4j">
                {NOT_FOR_YOU.map(item => <li key={item} className="flex items-start gap-4" data-id="element-125" data-mp="334e6s1l8lxjl">
                    <div className="bg-charcoal-light p-1 rounded-sm shrink-0 mt-0.5" data-id="element-126" data-mp="384s3wolavn2u">
                      <XIcon className="w-5 h-5 text-offwhite-dim" data-id="element-127" data-mp="3cxbseglj02mf" />
                    </div>
                    <span className="text-offwhite-dim/80 text-lg" data-id="element-128" data-mp="3hw68has3zd2u">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}